import { render, staticRenderFns } from "./RegistroDeSaques.vue?vue&type=template&id=6fd05b6b&scoped=true"
import script from "./RegistroDeSaques.vue?vue&type=script&lang=js"
export * from "./RegistroDeSaques.vue?vue&type=script&lang=js"
import style0 from "./RegistroDeSaques.vue?vue&type=style&index=0&id=6fd05b6b&prod&lang=css"
import style1 from "./RegistroDeSaques.vue?vue&type=style&index=1&id=6fd05b6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd05b6b",
  null
  
)

export default component.exports